export default "__VITE_ASSET__CCMLEOOG__"